import Vue from 'vue'
import Router from 'vue-router'

const Layout = resolve => require(['@/views/Layout'], resolve)
const ChatPc = resolve => require(['@/views/Chat/Pc'],resolve)
const ChatMobile = resolve => require(['@/views/Chat/Mobile'],resolve)

// 测试会话
const Charvalidation = resolve => require(['@/views/Chat/Charvalidation'],resolve)

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: Layout,
    },
    {
      path: '/chatpc',
      name: 'ChatPc',
      component: ChatPc
    },
    {
      path: '/chatmobile',
      name: 'ChatMobile',
      component: ChatMobile
    },
    {
      path: '/charvalidation',
      name: 'Charvalidation',
      component: Charvalidation
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js